<template>
  <div style="padding-top:-2px;margin-top:-2px;" class="s-select-public-definition">
    <v-label v-if="showLabel && computedLabel">
      <b>{{ computedLabel }}</b>
    </v-label>
    <v-select
      v-model="internalValue"
      :items="items"
      :item-text="abbr ? 'DedAbbreviation' : 'DedDescription'"
      :item-value="id"
      :return-object="returnObject"
      :disabled="disabled"
      :readonly="readonly"
      :clearable="clearable"
      :multiple="multiple"
      :outlined="outlined"
      :dense="dense"
      :rules="rules"
      :loading="loading"
      placeholder=" "
      hide-details="auto"
      @change="onChange"
    >
      <template v-if="$scopedSlots.item" v-slot:item="slotProps">
        <slot name="item" v-bind="slotProps"></slot>
      </template>
    </v-select>
  </div>
</template>

<script>
import DefinitionService from "@/services/General/DefinitionService";

export default {
  name: "SSelectPublicDefinition",
  props: {
    value: {
      default: null,
    },
    def: {
      type: Number,
      required: true,
      default: 0,
    },
    dgr: {
      type: Number,
      default: 0,
    },
    id: {
      type: String,
      default: "DedValue",
    },
    abbr: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      internalValue: null,
    };
  },
  computed: {
    computedLabel() {
      if (this.label) return this.label;
      if (this.items.length > 0 && this.items[0].DefDescription) {
        return this.items[0].DefDescription;
      }
      return "";
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.internalValue = newVal;
      },
      immediate: true,
    },
    internalValue(newVal) {
      this.$emit("input", newVal);
    },
    def: {
      handler(newDef) {
        if (newDef > 0) {
          this.loadPublicDefinition();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async loadPublicDefinition() {
      if (!this.def || this.def <= 0) return;
      this.loading = true;
      try {
        const response = await DefinitionService.publicDefinitionGroup(this.def, this.dgr);
        if (response && response.status === 200) {
          this.items = response.data || [];
          this.$emit("updateData", this.items);
        } else {
          this.items = [];
        }
      } catch (error) {
        console.error(`Error al cargar definición pública defID=${this.def}:`, error);
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    onChange(val) {
      this.$emit("change", val);
    },
  },
};
</script>

<style scoped>
.s-select-public-definition {
  width: 100%;
}
</style>
